var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalParkingOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bus_states",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_456",
    "data-name": "Rectangle 456",
    width: 13,
    height: 18,
    fill: "#4c51b0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#35ac25",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2131",
    "data-name": "Groupe 2131",
    transform: "translate(6 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2130",
    "data-name": "Groupe 2130",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_781",
    "data-name": "Trac\\xE9 781",
    d: "M7,0H0V18H4V12H7A6,6,0,0,0,7,0m.2,8H4V4H7.2a2,2,0,0,1,0,4",
    fill: "#4c51b0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalParkingOutlined);
export default __webpack_public_path__ + "static/media/LocalParkingOutlined.9e46e396ee76830f78e05efdd2cdcd7d.svg";
export { ForwardRef as ReactComponent };